(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["main-product-contact-details"] && !Shopify.designMode) return;
  try {
    if (!window.__ttLiveChatInit) {
      window.__ttLiveChatInit = true;

      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-open-live-chat]');
        if (!trigger) return;
        event.preventDefault();

        var chat = document.querySelector('shopify-chat');
        if (!chat) return;

        // Open-mode shadow root: click the widget's own activator button.
        var root = chat.shadowRoot;
        var button = root && root.querySelector('button, [role="button"]');
        if (button) {
          button.click();
          return;
        }

        // Fallback: some builds listen for a click on the host element itself.
        chat.click();
      });
    }
  } catch(e) { console.error(e); }
})();

})();
